import { Component, ElementRef, ViewChild, OnInit, Output, EventEmitter, OnDestroy, Input } from '@angular/core';
import { Router } from '@angular/router';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { DataService } from '../../../../core/data/data-service';
import { CommonService } from '../../../../common/services/common.service';
import { StoreLogoService } from '../../../../core/routing/services/asset-library/store-logo.service';
import { GlobalConstants } from './../../../../common/constants/global.constant';
import { GetStoreLogoByUserResponse, StoreLogoViewModel, StoreLogoConfiguration, CreateStoreLogoResponse } from '../../../../modules/asset-library/logo-content/interfaces/store-logo.i';
import { ProfileStoreService } from '../../../../modules/create-profile/store/profile.store';
import { StoreLogo, ProfileRequest } from 'src/app/modules/create-profile/interface/profile.i';
import { CreateProfileService } from '../../../../core/routing/services/profile/create-profile.service';
import { AppGlobal } from 'src/app/core/state/app-global';
import { User } from 'src/app/modules/account/login/_models/user.model';
import { GoogleAnalyticsService } from 'src/app/modules/google-analytics/google-analytics.service';
import { DeviceWallpaper } from 'src/app/modules/asset-library/logo-content/interfaces/device-wallpaper';
import { Utils } from 'src/app/common/utils/utils';

@Component({
  selector: 'iposcen-profile-storelogo',
  templateUrl: './profile-storelogo.component.html',
  styleUrls: ['./profile-storelogo.component.scss']
})
export class ProfileStorelogoComponent implements OnInit, OnDestroy {
  @Output() readonly setLogoContentTab = new EventEmitter<any>();
  @Output() readonly setTabIndex = new EventEmitter<any>();
  @Output() readonly setTabIndexDWP = new EventEmitter<any>();
  @Output() readonly disabledLogoContentTab = new EventEmitter<any>();
  @ViewChild('showModal') showModal: ElementRef;
  @Input() deviceWallPaper: string = 'default';
  @Input() wallpaperTab;
  @Input() iposlite: boolean;
  @Input() logoPresentPage;
  showDevice = false;
  tabIndex = 0;
  storeLogoData: [];
  defaultStoreLogos: StoreLogoViewModel[] = [];
  defaultDeviceWallPaper: StoreLogoViewModel[] = [];
  otherStoreLogos: StoreLogoViewModel[] = [];
  otherDeviceWallPaper: StoreLogoViewModel[] = [];
  currentStoreLogo: any = [];
  selectedLogoForProfile: any = [];
  @Output() readonly currentStoreLogoCount = new EventEmitter<any>();
  dataToProfile: any;
  storeLogoBgColor: string;
  isImageSizeError: boolean;
  isImageTypeError: boolean;
  isImageUploadError: boolean;
  isimageFormat: boolean;
  livePreviewData: any = [];
  skip: string;
  send: string;
  profileStoreLogoData: any = [];
  profileData: ProfileRequest;
  removeConstraints: boolean;
  isRemoveEnabled: boolean;
  storeLogoLabel = GlobalConstants.STORE_LOGO_LABEL;
  direction: string;
  placementWithLogo: string;
  placementWithoutLogo: string;
  isImgVideoSizeInfoEnabled: boolean;
  isArabic = localStorage.getItem('preferredLanguage') === 'ar-sa';
  isHebrew = localStorage.getItem('preferredLanguage') === 'he';
  changePlacement: boolean;
  removeStoreLogo = false;
  removeDeviceWallPaper = false;
  isStoreLogoRemoved = true;
  isDeviceWallPaperRemoved = true;
  private ngUnsubscribe = new Subject<boolean>();
  logoUploaded: boolean;
  selectedDeviceWallPaperForProfile: any[];
  profileDeviceWallPaperData: DeviceWallpaper[];
  inDeviceWallPaperTab: boolean;
  deviceWallPaperBgColor: string;
  currentDeviceWallPaper: any = [];
  wallPaperThumbNailTxt = GlobalConstants.DEVICE_WALLPAPER_THUMBNAIL_TXT;
  wallPaperImagUpload = GlobalConstants.DEVICE_IMG_LI;
  noProfileStoreLogoMsg = true;
  isDWPEnabled: boolean;
  clearSelectionImg: boolean = false;
  
  constructor(private router: Router,
    private storeLogoService: StoreLogoService,
    private cmnService: CommonService,
    private profileStoreService: ProfileStoreService,
    private createProfileService: CreateProfileService,
    private appGlobal: AppGlobal,
    private dataService: DataService,
    private googleAnalyticService: GoogleAnalyticsService) { }

  ngOnInit(): void {
    if (this.isArabic || this.isHebrew) {
      this.changePlacement = true;
    }
    this.direction = this.cmnService.direction;
    this.placementWithoutLogo = this.direction === "rtl" ? 'left' : 'right';
    this.placementWithLogo = this.direction === "rtl" ? 'right' : 'left';
    this.skip = GlobalConstants.SKIP;
    this.send = GlobalConstants.SEND;
    this.storeLogoBgColor = GlobalConstants.STORELOGO_BGCOLOR;
    this.deviceWallPaperBgColor = GlobalConstants.STORELOGO_BGCOLOR;
    this.inDeviceWallPaperTab = this.deviceWallPaper === GlobalConstants.DEVICE_WALLPAPER_ID;
    
    this.getAllStoreLogosByUser();
    this.appGlobal.$userAccount
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((userAccount: User) => {
        this.isRemoveEnabled = userAccount.isRemoveEnabled;
      });
    this.logoUploaded = false;
    const existingProfileData = JSON.parse(JSON.stringify(this.profileStoreService.currentWorkingProfile));
    if (existingProfileData && existingProfileData?.profileId) {
      this.profileData = existingProfileData as ProfileRequest;
      this.isDWPEnabled = Utils.checkOSTypeWindowsOrUWP(this.profileData);
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  setIndex(value: number) {
    this.tabIndex = value;
  }
  setStoreLogo(logo: any) {
    let defaultLogoSelected : StoreLogoViewModel[] = [];
    defaultLogoSelected = this.inDeviceWallPaperTab
      ? this.setDefaultLogoTabWise( this.defaultDeviceWallPaper,logo, this.otherDeviceWallPaper)
      : this.setDefaultLogoTabWise( this.defaultStoreLogos,logo,  this.otherStoreLogos);
    
 
    this.currentStoreLogoCount.emit(defaultLogoSelected);
    this.setLivePreview();
  }
  setDefaultLogoTabWise(defaultStoreLogoList: StoreLogoViewModel[], selectedItem, storeLogoMasterList:StoreLogoViewModel[]){
    let filteredCollection = storeLogoMasterList.filter( ({ id }) => id !== selectedItem.id );
    this.inDeviceWallPaperTab ? (this.otherDeviceWallPaper = filteredCollection) : (this.otherStoreLogos = filteredCollection);
    if (defaultStoreLogoList.length < 1) {
      defaultStoreLogoList.push(selectedItem);
      defaultStoreLogoList[0].isdefault = true;
    } else {
      const data = defaultStoreLogoList.pop();
      defaultStoreLogoList.push(selectedItem);
      defaultStoreLogoList[0].isdefault = true;
      if (this.inDeviceWallPaperTab) {
        this.otherDeviceWallPaper.push(data);
        this.isDeviceWallPaperRemoved = true;
      } 
      else { 
        this.otherStoreLogos.push(data);
        this.isStoreLogoRemoved = true;
      }
    }
    defaultStoreLogoList = Object.assign( [],defaultStoreLogoList);
    return defaultStoreLogoList;
  }
 
  getAllStoreLogosByUser() {
    this.isImgVideoSizeInfoEnabled = this.cmnService.isSizeContraintsEnabled;
    this.storeLogoService.getAllStoreLogoByUser()
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getAllStoreLogoResponse => {
        const storeLogos = [];
        const getStoreLogoByUserResponse: GetStoreLogoByUserResponse = getAllStoreLogoResponse as GetStoreLogoByUserResponse;
        getStoreLogoByUserResponse.storeLogo.forEach(storeLogo => {
          const reader = new FileReader();
          const storeLogoViewModel: StoreLogoViewModel = storeLogo as StoreLogoViewModel;
          this.storeLogoService.getStoreLogoById(storeLogo.id)
            .pipe(takeUntil(this.ngUnsubscribe))
            .pipe(first())
            .subscribe(imageData => {
              reader.addEventListener('load', () => {
                storeLogoViewModel.imageData = reader.result;
                const storeLogoConfiguration = JSON.parse(storeLogo.configurations) as StoreLogoConfiguration;
                storeLogoViewModel.fileName = storeLogoConfiguration.fileName;
                storeLogos.push(storeLogoViewModel);
                storeLogos.forEach(ele => {
                  if (ele.fileName?.split('.')[0].length > 20) {
                    let fileName = ele.fileName;
                    let extension = fileName.substring(fileName.lastIndexOf('.') + 1);
                    fileName = fileName.substring(0, 20);
                    ele.shortFileName = `${fileName}...${extension}`;
                  } else {
                    ele.shortFileName = ele.fileName;
                  }
                  ele.updateTime = new Date(ele.updateTime);
                  ele.updateTimeDisplay = new Date(ele.updateTime).toLocaleString()
                    .replace(',', '');
                });
                const existingProfileData = JSON.parse(JSON.stringify(this.profileStoreService.currentWorkingProfile));
                if (existingProfileData && existingProfileData?.profileId) {
                  this.profileData = existingProfileData as ProfileRequest;
                  this.profileStoreLogoData = this.profileData.storeLogos as StoreLogo[];
                  this.profileDeviceWallPaperData = this.profileData?.deviceWallpaper as DeviceWallpaper[];
                  const deviceWallPaperId = this.profileDeviceWallPaperData ? this.profileDeviceWallPaperData[0]?.deviceWallpaperId : '';
                  
                  if (this.inDeviceWallPaperTab) {
                    if (this.profileDeviceWallPaperData && deviceWallPaperId ) { // if Edit profilelogo
                      this.defaultDeviceWallPaper = storeLogos.filter(ele => deviceWallPaperId === ele.id);
                      this.otherDeviceWallPaper = storeLogos.filter(ele => deviceWallPaperId !== ele.id);
                    }else {
                      this.defaultDeviceWallPaper = storeLogos.filter(ele => ele.isdefault);
                      this.setLivePreview();
                      this.otherDeviceWallPaper = storeLogos.filter(ele => !ele.isdefault);
                    }

                    if (this.inDeviceWallPaperTab && deviceWallPaperId && deviceWallPaperId?.indexOf(this.profileData.profileId) == -1) {
                      this.deviceWallPaperBgColor = this.profileDeviceWallPaperData[0]?.bgColor;
                    } else if (this.profileStoreLogoData[0]?.bgColor) { //Condition to handle if bgColor doesn't exist already.
                      this.storeLogoBgColor = this.profileStoreLogoData[0]?.bgColor;
                    }
                  } else {
                    if (this.profileStoreLogoData?.length) { // if Edit profilelogo
                      this.defaultStoreLogos = storeLogos.filter(ele => this.profileStoreLogoData[0].storeLogoId === ele.id);
                      this.otherStoreLogos = storeLogos.filter(ele => this.profileStoreLogoData[0].storeLogoId !== ele.id);
                    if (this.profileStoreLogoData[0].bgColor) { //Condition to handle if bgColor doesn't exist already.
                       this.storeLogoBgColor = this.profileStoreLogoData[0].bgColor;
                      }
                    } else {
                    this.defaultStoreLogos = storeLogos.filter(ele => ele.isdefault);
                    this.otherStoreLogos = storeLogos.filter(ele => !ele.isdefault);
                    this.noProfileStoreLogoMsg = (this.defaultStoreLogos.length === 0) && (this.otherStoreLogos.length === 0) || false;
                    } this.noProfileStoreLogoMsg = (this.defaultStoreLogos.length === 0) && (this.otherStoreLogos.length === 0) || false;
                  }

                } else {
                  if (this.inDeviceWallPaperTab) {
                    this.defaultDeviceWallPaper = storeLogos.filter(ele => ele.isdefault);
                    this.otherDeviceWallPaper = storeLogos.filter(ele => !ele.isdefault);
                    this.setLivePreview();
                  }else {
                    this.defaultStoreLogos = storeLogos.filter(ele => ele.isdefault);
                    this.otherStoreLogos = storeLogos.filter(ele => !ele.isdefault);
                    this.noProfileStoreLogoMsg = (this.defaultStoreLogos.length === 0) && (this.otherStoreLogos.length === 0) || false;
                  }
                }
                this.setLivePreview();
                if (this.inDeviceWallPaperTab) {
                  this.defaultDeviceWallPaper = Object.assign([], this.defaultDeviceWallPaper);
                  this.currentStoreLogoCount.emit(this.defaultDeviceWallPaper);
                  if (this.defaultDeviceWallPaper?.length === 0) {
                  this.disabledLogoContentTab.emit(true);
                  }
                } else {
                  this.defaultStoreLogos = Object.assign([], this.defaultStoreLogos);
                  this.currentStoreLogoCount.emit(this.defaultStoreLogos);
                  if (this.defaultStoreLogos.length === 0) {
                    this.disabledLogoContentTab.emit(true);
                }
                }
                  
              }, false);

              if (imageData) {
                reader.readAsDataURL(imageData);
              }
            },
              error => {
                // do something
              });
        });
      },
        error => {
          if (this.defaultDeviceWallPaper) {
            if (this.defaultDeviceWallPaper?.length === 0) {
              this.disabledLogoContentTab.emit(true);
            }
          } else {
            if (this.defaultStoreLogos?.length === 0) {
              this.disabledLogoContentTab.emit(true);
            }
          }
        });
  }

  processFile(imageInput: any) {
    const file: File = imageInput.files[0];
    const reader = new FileReader();
    const fileType = file.type.split('/')[1];
    const excludeGIFFormat = (this.inDeviceWallPaperTab && fileType === GlobalConstants.CONTENT_TYPE_GIF) ? true : false;
    if ((file.type.split('/')[0] === GlobalConstants.FILE_TYPE_IMAGE) && !excludeGIFFormat) {
      this.isImageSizeError = file.size > GlobalConstants.UPLOAD_LOGO_IMAGE_SIZE_5MB;
      this.isImageTypeError = fileType !== GlobalConstants.CONTENT_TYPE_JPEG &&
        fileType !== GlobalConstants.CONTENT_TYPE_PNG &&
        fileType !== GlobalConstants.CONTENT_TYPE_GIF;
      if (this.isRemoveEnabled || this.isImgVideoSizeInfoEnabled) {
        this.isImageSizeError = false;
      }
      this.isImageUploadError = (this.isImageSizeError || this.isImageTypeError || (this.isImageSizeError && this.isImageTypeError));
      this.isimageFormat = true;
    } else {
      this.isimageFormat = false;
      this.isImageTypeError = true;
      this.isImageUploadError = true;
    }
    if (!this.isImageUploadError) {
      reader.addEventListener('load', (event: any) => {
        const storeLogo = {
          fileName: file.name
        };
        this.storeLogoService.createStoreLogo(JSON.stringify(storeLogo))
          .pipe(takeUntil(this.ngUnsubscribe))
          .pipe(first())
          .subscribe(createStoreLogo => {
            const createStoreLogoResponse: CreateStoreLogoResponse = createStoreLogo as CreateStoreLogoResponse;
            const storeLogoViewModel: StoreLogoViewModel = createStoreLogoResponse.storeLogo as StoreLogoViewModel;
            this.storeLogoService.uploadImage(file, createStoreLogoResponse.storeLogo.id, file.name.split('.')
              .pop())
              .pipe(takeUntil(this.ngUnsubscribe))
              .pipe(first())
              .subscribe(() => {
                if (!this.otherStoreLogos || (this.otherStoreLogos && this.otherStoreLogos.length === 0)) {
                  this.otherStoreLogos = [];
                }
                if (this.otherDeviceWallPaper?.length === 0) {
                  this.otherDeviceWallPaper = [];
                }
                this.openModal(this.showModal);
                storeLogoViewModel.imageData = event.target.result;
                if (file.name?.split('.')[0].length > 20) {
                  let uploadFileName = file.name;
                  let extension = uploadFileName.substring(uploadFileName.lastIndexOf('.') + 1);
                  uploadFileName = uploadFileName.substring(0, 20);
                  storeLogoViewModel.shortFileName = `${uploadFileName}...${extension}`;
                } else {
                  storeLogoViewModel.shortFileName = file.name;
                }
                storeLogoViewModel.fileName = file.name;
                storeLogoViewModel.updateTime = new Date(storeLogoViewModel.updateTime);
                storeLogoViewModel.updateTimeDisplay = new Date(storeLogoViewModel.updateTime).toLocaleString()
                  .replace(',', '');
                this.inDeviceWallPaperTab ?  this.otherDeviceWallPaper.push(storeLogoViewModel) :  this.otherStoreLogos.push(storeLogoViewModel);
                this.noProfileStoreLogoMsg = (this.otherStoreLogos.length === 0) || false;
                this.sortByCreatedDate();
                this.logoUploaded = true;
              },
                error => {
                  // do something
                });
          },
            error => {
              // do something
            });
      });
    }

    reader.readAsDataURL(file);
  }

  sendToProfile(action: string) {
    if (action === GlobalConstants.SEND ) {
      if (this.inDeviceWallPaperTab ) {       
          this.selectedDeviceWallPaperForProfile = [];
          if (this.defaultDeviceWallPaper?.length > 0) {
          this.selectedDeviceWallPaperForProfile?.push({
            deviceWallpaperId: this.defaultDeviceWallPaper[0]?.id,
            showOnDevice: true,
            bgColor: this.deviceWallPaperBgColor
          });
        } else {
          this.selectedDeviceWallPaperForProfile?.push({
            showOnDevice: false
          });
        }
          this.cmnService.emitDataToProfile({ page: GlobalConstants.DEVICE_WALLPAPER, dataSet: this.selectedDeviceWallPaperForProfile });
          this.setLogoContentTab.emit(GlobalConstants.CREATE_PROFILE);
          this.setTabIndex.emit(1);
          this.defaultDeviceWallPaper = Object.assign([], this.defaultDeviceWallPaper);
          this.currentStoreLogoCount.emit(this.defaultDeviceWallPaper);
        this.cmnService.emitDataToProfile({ page: GlobalConstants.LOGO_CONTENT_GROUP, dataSet: GlobalConstants.SKIP });
        this.googleAnalyticService.profileDeviceWallPaper(this.profileData.profileId, this.profileData.profileName, GlobalConstants.MAKE_LOGO_WALPAPER);
      } else if (this.defaultStoreLogos.length > 0) {
        this.selectedLogoForProfile = [];
        this.selectedLogoForProfile.push({
          storeLogoId: this.defaultStoreLogos[0].id,
          showOnDevice: true,
          bgColor: this.storeLogoBgColor
        });
        this.cmnService.emitDataToProfile({ page: GlobalConstants.STORE_PAGE, dataSet: this.selectedLogoForProfile });
        this.setLogoContentTab.emit(GlobalConstants.CREATE_PROFILE);
        if (!this.iposlite) this.setTabIndex.emit(1);
        this.defaultStoreLogos = Object.assign([], this.defaultStoreLogos);
        this.currentStoreLogoCount.emit(this.defaultStoreLogos);
      }
    }
    if (action === GlobalConstants.SKIP) {
      if (this.isDWPEnabled) {
        this.setTabIndexDWP.emit(2);
        this.cmnService.emitDataToProfile({ page: GlobalConstants.STORE_PAGE, dataSet: GlobalConstants.SKIP, type: GlobalConstants.DEVICE_WALLPAPER });
      } else {
        this.cmnService.emitDataToProfile({ page: GlobalConstants.STORE_PAGE, dataSet: GlobalConstants.SKIP });
      }
    } else if (action == GlobalConstants.SKIP_DWP) {
      this.cmnService.emitDataToProfile({ page: GlobalConstants.DEVICE_WALLPAPER, dataSet: GlobalConstants.SKIP });
    }
    window['dataLayer'].push({
      'profile_info_added': true
    })
    if(this.logoUploaded) {
      this.googleAnalyticService.storeLogoAdded();
    }
  }

  setLivePreview() {
    this.livePreviewData = [];
    if (this.inDeviceWallPaperTab) {
      this.livePreviewData.push({
        imageData: this.defaultDeviceWallPaper[0]?.imageData,
        bgColor: this.deviceWallPaperBgColor,
        type: GlobalConstants.DEVICE_WALLPAPER_ID,
        isDWPOptionSelected : true
      });
    } else {
      this.livePreviewData.push({
        imageData: this.defaultStoreLogos[0]?.imageData,
        bgColor: this.storeLogoBgColor,
        clearSelectionImg:this.clearSelectionImg
      });
    }
    this.clearSelectionImg=false;
    this.cmnService.emitLivePreviewDataToProfile(this.livePreviewData);
  }

  updateBgColor(value: string) {
    this.inDeviceWallPaperTab ? this.deviceWallPaperBgColor = value : this.storeLogoBgColor = value;
    this.setLivePreview();
  }

  sortByCreatedDate() {
   this.inDeviceWallPaperTab ?  this.otherDeviceWallPaper.sort((logo1, logo2) => (logo2.updateTime as any) - (logo1.updateTime as any)) :this.otherStoreLogos.sort((logo1, logo2) => (logo2.updateTime as any) - (logo1.updateTime as any));
  }

  openModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }
  redirectToList() {
    this.closeModal(this.showModal);
  }
  showOnDeviceForCollection(defaultStoreLogoList: StoreLogoViewModel[], storeLogoMasterList:StoreLogoViewModel[]) {
    let currentStoreLogoItem:any = [];
    currentStoreLogoItem =storeLogoMasterList[0];
    storeLogoMasterList = storeLogoMasterList.filter(({ id }) => id !== currentStoreLogoItem?.id);

    if (defaultStoreLogoList?.length == 0) {
      defaultStoreLogoList.push(currentStoreLogoItem);
      defaultStoreLogoList[0].isdefault = true;
    } else {
      const data = defaultStoreLogoList.pop();
      defaultStoreLogoList.push(currentStoreLogoItem);
      defaultStoreLogoList[0].isdefault = true;
     storeLogoMasterList.push(data);
    }
    defaultStoreLogoList = Object.assign([], defaultStoreLogoList);
    this.currentStoreLogoCount.emit(defaultStoreLogoList);
    this.inDeviceWallPaperTab ? this.otherDeviceWallPaper = storeLogoMasterList : this.otherStoreLogos = storeLogoMasterList;
    this.inDeviceWallPaperTab ? this.defaultDeviceWallPaper = defaultStoreLogoList : this.defaultStoreLogos = defaultStoreLogoList;
    this.inDeviceWallPaperTab ? this.currentDeviceWallPaper = currentStoreLogoItem : this.currentStoreLogo = currentStoreLogoItem;
  }
  showOnDevice() {
    this.showDevice = true;
    this.inDeviceWallPaperTab ? this.showOnDeviceForCollection(this.defaultDeviceWallPaper,this.otherDeviceWallPaper) :
    this.showOnDeviceForCollection(this.defaultStoreLogos,this.otherStoreLogos)
    this.setLivePreview();
    this.redirectToList();
  }

  closeShowOnDevice() {
    this.showDevice = false;
    this.inDeviceWallPaperTab ? this.defaultDeviceWallPaper = Object.assign([], this.defaultDeviceWallPaper) :  this.defaultStoreLogos = Object.assign([], this.defaultStoreLogos);
    this.inDeviceWallPaperTab ? this.currentStoreLogoCount.emit(this.defaultDeviceWallPaper) : this.currentStoreLogoCount.emit(this.defaultStoreLogos);
    this.redirectToList();
  }
 
  clearItemSelection(defaultStoreLogoList: StoreLogoViewModel[], storeLogoMasterList:StoreLogoViewModel[], isDefault,storeLogoId: string) {
    if (!isDefault) {
       defaultStoreLogoList.forEach(element => {
        element.isdefault = false;
      });
      storeLogoMasterList = storeLogoMasterList.concat(defaultStoreLogoList);
      defaultStoreLogoList.pop();
    } else {
      const storeLogos = defaultStoreLogoList.concat(storeLogoMasterList);
      storeLogos.forEach(element => {
        element.isdefault = false;
        if (element.id === storeLogoId) {
          element.isdefault = true;
          defaultStoreLogoList.push(element);
        }
      });
      defaultStoreLogoList = storeLogos.filter(ele => ele.isdefault);
      storeLogoMasterList = storeLogos.filter(ele => !ele.isdefault);
    } 
      this.inDeviceWallPaperTab ? this.isDeviceWallPaperRemoved = false : this.isStoreLogoRemoved = false;
      this.inDeviceWallPaperTab ? this.otherDeviceWallPaper = storeLogoMasterList : this.otherStoreLogos = storeLogoMasterList;
      this.inDeviceWallPaperTab ? this.defaultDeviceWallPaper = defaultStoreLogoList : this.defaultDeviceWallPaper = defaultStoreLogoList;
  }

  clearSelection(storeLogoId: string, isDefault: boolean) {
    this.clearSelectionImg= true;
    this.inDeviceWallPaperTab ? this.clearItemSelection(this.defaultDeviceWallPaper,this.otherDeviceWallPaper,isDefault,storeLogoId)
    : this.clearItemSelection(this.defaultStoreLogos,this.otherStoreLogos,isDefault,storeLogoId);
    this.setLivePreview();
  }
}
